import full_page_children from './full_page'
import main_children from './main'

const routes = [
    {
        // =============================================================================
        // MAIN LAYOUT ROUTES
        // =============================================================================
        path: '',
        component: () => import('@/layouts/main/Main.vue'),
        children: [
            // =============================================================================
            // Theme Routes
            // =============================================================================
            ...main_children
        ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
        path: '',
        component: () => import('@/layouts/full-page/FullPage.vue'),
        children: full_page_children
    },
    // Redirect to 404 page, if no match found
    {
        path: '*',
        redirect: { name: '404' }
    }
]

export default routes
